import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Avatar, Box, ButtonBase, Divider, ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import { Logout as LogoutIcon, SettingsOutlined as SettingsIcon, Telegram as TelegramIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../contexts/AuthContext';
import { tokens } from '../../theme/tokens';

/** The avatar at the top right on a phone: settings, Telegram and the way out. */
const AccountMenu: React.FC = () => {
  const { t } = useTranslation('navigation');
  const navigate = useNavigate();
  const { state, logout } = useAuth();
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);
  const user = state.user;
  const close = () => setAnchor(null);

  const go = (path: string) => {
    close();
    navigate(path);
  };

  const handleLogout = async () => {
    close();
    await logout();
    navigate('/');
  };

  return (
    <>
      <ButtonBase
        onClick={(event) => setAnchor(event.currentTarget)}
        aria-label={t('shell.account')}
        aria-haspopup='menu'
        sx={{ borderRadius: '50%' }}
      >
        <Avatar sx={{ width: 40, height: 40, fontSize: 15, bgcolor: tokens.accentSoft2, color: tokens.accent }}>
          {user?.firstName?.charAt(0).toUpperCase() || '?'}
        </Avatar>
      </ButtonBase>
      <Menu
        anchorEl={anchor}
        open={Boolean(anchor)}
        onClose={close}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        MenuListProps={{ sx: { minWidth: 220, py: 0.75 } }}
      >
        {user && (
          <Box sx={{ px: 2, pt: 1, pb: 1.25, display: 'flex', flexDirection: 'column' }}>
            <Box component='strong' sx={{ fontSize: 14 }}>{user.fullName || user.firstName}</Box>
            <Box component='span' sx={{ fontSize: 12.5, color: tokens.ink3 }}>{user.email}</Box>
          </Box>
        )}
        <Divider sx={{ my: 0.5 }} />
        <MenuItem onClick={() => go('/settings')}>
          <ListItemIcon><SettingsIcon fontSize='small' /></ListItemIcon>
          <ListItemText>{t('menu.settings')}</ListItemText>
        </MenuItem>
        <MenuItem onClick={() => go('/settings/telegram')}>
          <ListItemIcon><TelegramIcon fontSize='small' /></ListItemIcon>
          <ListItemText>{t('shell.telegram')}</ListItemText>
        </MenuItem>
        <Divider sx={{ my: 0.5 }} />
        <MenuItem onClick={handleLogout}>
          <ListItemIcon><LogoutIcon fontSize='small' /></ListItemIcon>
          <ListItemText>{t('header.logout')}</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
};

export default AccountMenu;
